<template>
	<section style="height: 100%;">
		<div class="col" style="height: 100%;">
			<div class="row" style="height: 100%;">
				<div class="col-lg-5">
					<ValidationObserver tag="form" v-slot="{ invalid }" class="mx-auto col-lg-10" ref="observer">
						<form @submit.prevent="login()">
							<img src="/img/Logo.png" alt="Bisa Cek" class="group-2 mb-4 mx-auto d-block img-fluid" style="width: 234px;margin-top:50px;">
							<h4 class="mb-4 mt-4"><b>Masuk</b></h4>

							<div class="alert alert-danger f-12" v-if="authFalse">
								{{ errMessage }}
							</div>

							<ValidationProvider name="Email" rules="required|email">
								<div class="form-group" slot-scope="{ errors }">
									<label class="form-label f-14">Email</label>
									<input type="email" v-model="email" class="form-control" :class="{ 'error': errors[0] || authFalse }" placeholder="Masukkan email">
									<div class="f-12 text-danger">{{ errors[0] }}</div>
								</div>
							</ValidationProvider>

							<ValidationProvider name="Password" rules="required|alpha_num">
								<div class="form-group" slot-scope="{ errors }">
									<label class="form-label f-14">Kata Sandi</label>
									<div class="input-group" :class="{ 'error': errors[0] || authFalse }" id="show_hide_password">
										<input type="password" v-model="password" class="form-control append-button" placeholder="Masukkan kata sandi">
										<div class="input-group-append">
											<span class="input-group-text">
												<i class="fa fa-eye-slash" aria-hidden="true"></i>
											</span>
										</div>
									</div>
									<div class="f-12 text-danger mt-2">{{ errors[0] }}</div>
								</div>
							</ValidationProvider>
							<div class="float-right mb-1">
								<router-link tag="a" class="link f-14" to="lupa-password">Lupa kata sandi?</router-link>
							</div>
							<button :disabled="invalid" type="submit" class="btn btn-primary w-100 f-14 pd-10-20 mt-3">Masuk</button>
						</form>
					</ValidationObserver>

					<p class="f-14 text-center mt-4">Anda belum memiliki akun? <router-link to="/register" class="link f-14"><b>Daftar</b></router-link> disini</p>
				</div>
				<div class="d-none d-lg-block col-7"
					style="
						background-image: url('/img/login.png');
						background-color: #FFA827;
						background-repeat: round;
						height: 100%;
					">
					<div class="vertical-center" style="top:50%;">
						<img src="/img/login-1.png" alt="">
						<p class="text-white">Check every shipment easily</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import $ from 'jquery'
export default {
	data() {
		return {
			email: null,
			password: null,
			authFalse: false,
			message: null,
			errMessage: ''
		}
	},
	methods: {
		async login() {
			let _ = this
			const isValid = await this.$refs.observer.validate();
			if (!isValid) { 
				return;
			}
			_.axios.post('/auth/login', { email: _.email, password: _.password})
				.then(resp=>{
					if(resp.data.detail.status == 1){
						if(resp.data.detail.role == 4){						
							_.$store.dispatch('login', resp.data)
							if ( resp.data ) {
								_.$router.push('/my-order')
							} else {
								_.authFalse = true
							}
						} else {
							_.authFalse = true
						}
					}else {
						_.authFalse = true
						_.message = "Masuk gagal, akun anda dinonaktifkan."
					}					
				})
				.catch(err=>{
					if (err.response.data.error == 'inactive') {
						_.errMessage = 'Email Anda belum diverifikasi. Silakan cek email Anda untuk melakukan verifikasi.'
					} else {
						_.errMessage = 'Email atau kata sandi yang Anda masukkan tidak sesuai.'
					}
					
                    _.authFalse = true
				})
		}
	},
	mounted() {
		$("#show_hide_password span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password input').attr("type") == "text"){
	            $('#show_hide_password input').attr('type', 'password');
	            $('#show_hide_password i').addClass( "fa-eye-slash" );
	            $('#show_hide_password i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password input').attr("type") == "password"){
	            $('#show_hide_password input').attr('type', 'text');
	            $('#show_hide_password i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password i').addClass( "fa-eye" );
	        }
		});
		
		if (localStorage.getItem('token')){
			if (localStorage.getItem('role') == 4){
				this.$router.push('/my-order')
			}
		}
	}
}
</script>